import React from "react";
import ReactDom from "react-dom";
import FilmStrip from "./filmstrip";
import Carousel from "./carousel";
import * as utils from "./utils";

export default class GalleryPopup extends React.Component {
    constructor(props) {
        super(props);

        let selectedItem = props.selectedItem || 0
        if(props.data.media[selectedItem].type == "content") selectedItem++;        

        this.state = { selectedItem: selectedItem, goingNext: true };
        this.preloadedList = [];

        this.onClose = this.onClose.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onPrevOrNext = this.onPrevOrNext.bind(this);
        this.onSelectedItemChanged = this.onSelectedItemChanged.bind(this);
    }

    componentDidMount() {
        if (utils.isNullOrWhitespace(this.props.sidebarNodeSelector)) return;

        let sideBarContent = document.querySelector(this.props.sidebarNodeSelector);
        sideBarContent.style.display = "block";
        ReactDom.findDOMNode(this.refs.sidebarNode).appendChild(sideBarContent);

        document.addEventListener("keydown", this.onKeyDown, false);
        document.body.classList.add("fixed");
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeyDown, false);

        let sideBarContent = document.querySelector(this.props.sidebarNodeSelector);
        sideBarContent.style.display = "none";
        document.body.appendChild(sideBarContent);
        
        // reset tracking data
        if (CsnInsights) {
            CsnInsights.metaData.contentgroup2 = "details";
        }
    }

    onClose() {
        this.props.onClose && this.props.onClose();
        document.body.classList.remove("fixed");
    }

    onNext() {
        this.setState(prev => {
            let newIndex = prev.selectedItem + 1;
            if (newIndex >= this.props.data.media.length) newIndex = 0;
            return { selectedItem: newIndex, goingNext: true };
        });
    }

    onPrev() {
        this.setState(prev => {
            let newIndex = prev.selectedItem - 1;
            if (newIndex < 0) newIndex = this.props.data.media.length - 1;
            return { selectedItem: newIndex, goingNext: false };
        });
    }

    onPrevOrNext() {
        if (this.state.goingNext) this.onNext();
        else this.onPrev();
    }

    onSelectedItemChanged(e) {
        this.setState({ selectedItem: e });
    }

    onKeyDown(e) {
        switch (e.keyCode) {
            case 27: //Escape
                this.onClose();
                break;
            case 39: //Right Arrow
                this.onNext();
                break;
            case 37: //Left Arrow
                this.onPrev();
                break;
        }
    }

    preloadImage(indexToLoad) {
        if (this.preloadedList[indexToLoad] !== undefined)
            return;
        if (indexToLoad < 0 || indexToLoad >= this.props.data.media.length
            || this.props.data.media[indexToLoad].type === "video")
            return;

        let loadingImage = new Image();
        loadingImage.src = this.props.data.media[indexToLoad].contentUrl;
        this.preloadedList[indexToLoad] = loadingImage;
    }

    componentWillUpdate(nextProps, nextState) {
        let currentIndex = nextState.selectedItem;
        let maxLength = nextProps.data.media.length;
        let previousIndex = currentIndex == 0 ? maxLength - 1 : currentIndex - 1;
        let nextIndex = currentIndex == maxLength - 1 ? 0 : currentIndex + 1;

        this.preloadImage(previousIndex);
        this.preloadImage(nextIndex);

        $(window).trigger("Gallery.IndexChanged");
    }

    render() {
        const { selectedItem } = this.state;
        const currentItem = this.props.data.media[selectedItem];

        return (
            <div className="gallery-popup">
                <div className="wrapper container-fluid">
                    <div className="close" onClick={this.onClose} />
                    <div className="inner-wrapper">
                        <div className="row h-100">
                            <div className="col-9 d-flex h-100 flex-column">
                                <div className="row">
                                    <div className="col">
                                        <div className="title">{this.props.data.title}</div>
                                    </div>
                                    <div className="col-3">
                                        <div className="price">{this.props.data.price} {this.props.data.priceCurrency && <span className='price-currency'>{this.props.data.priceCurrency}</span> }</div>
                                        <div className="price-description">
                                            {this.props.data.priceDescription}
                                        </div>
                                    </div>
                                </div>
                                <div className="row fill d-flex">
                                    <Carousel
                                        item={currentItem}
                                        onNext={this.onNext}
                                        onPrev={this.onPrev}
                                        onPrevOrNext={this.onPrevOrNext} />
                                </div>
                                <div className="row">
                                    <FilmStrip
                                        thumbnails={this.props.data.media}
                                        value={selectedItem}
                                        onChange={this.onSelectedItemChanged}
                                    />
                                </div>
                                {this.props.data.disclaimer && (
                                    <div className="row">
                                        <div className="disclaimer">
                                            {this.props.data.disclaimer}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="col-3">
                                <div className="sidebar" ref="sidebarNode" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="overlay" onClick={this.onClose} />
            </div>
        );
    }
}
